import type { ComponentType } from 'react';

import type { StickerSlug } from '../stickers.ts';
import { Animals } from './Animals';
import { Birthday } from './Birthday';
import { Book } from './Book';
import { Cartoons } from './Cartoons';
import { Chat } from './Chat';
import { Colours } from './Colours';
import { Family } from './Family';
import { Food } from './Food';
import { Games } from './Games';
import { Music } from './Music';
import { Nature } from './Nature';
import { School } from './School';
import { Space } from './Space';
import { Sports } from './Sports';
import type { StickerArtProps } from './StickerFrame';
import { Toys } from './Toys';
import { Weather } from './Weather';

export type { StickerArtProps } from './StickerFrame';

/** A `Record`, so a slug added to `STICKER_SLUGS` without art fails `tsc`. */
export const STICKER_ART: Record<StickerSlug, ComponentType<StickerArtProps>> = {
  space: Space,
  animals: Animals,
  food: Food,
  games: Games,
  family: Family,
  colours: Colours,
  school: School,
  sports: Sports,
  toys: Toys,
  book: Book,
  music: Music,
  weather: Weather,
  birthday: Birthday,
  nature: Nature,
  cartoons: Cartoons,
  chat: Chat,
};
